import { Common } from './Common';

export class Master extends Common {
    category: string;
    type: string;
    name: string;
    parent_id: string;
    parent_ids: string;
    level: number;

    requested_by: string;
    business_id: string;

    religion: string;
    caste: string;
    community: string;
    sub_community: string;
    country: string;
    state: string;
    district: string;
    location: string;
    showChild: boolean;
}
